import { isEmpty } from 'ramda'

import {
  APPLY_TEMPLATE_TYPE_CUSTOM,
  APPLY_TEMPLATE_TYPE_DAIMLER,
  APPLY_TEMPLATE_TYPE_DAIMLER_ORGID,
} from 'constants/ui/ptoDiagram'

export const getFilteredTemplateList = (
  templatesList,
  templateType,
  query = '',
  comparator
) => {
  if (!isEmpty(templatesList)) {
    const filteredList = templatesList.filter((item) => {
      const { partNumber, name, author, templateDescription } = item
      const matches =
        query && query.length >= 1
          ? [partNumber, name, author, templateDescription].filter(
              (property) => {
                const words = `${query}`
                  .split(' ')
                  .filter((word) => Boolean(word))
                return words.some(
                  (word) =>
                    `${property}`
                      .toUpperCase()
                      .indexOf(`${word}`.toUpperCase()) > -1
                )
              }
            ).length > 0
          : true

      const isDaimlerTemplate = item.orgId === APPLY_TEMPLATE_TYPE_DAIMLER_ORGID

      let validTemplate = false

      if (templateType === APPLY_TEMPLATE_TYPE_DAIMLER) {
        validTemplate = isDaimlerTemplate
      } else if (templateType === APPLY_TEMPLATE_TYPE_CUSTOM) {
        validTemplate = !isDaimlerTemplate
      }

      return validTemplate && matches
    })
    const sorted = comparator ? filteredList.sort(comparator) : filteredList

    return sorted
  }

  return []
}
